import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { FunctionComponent } from "react";
import { CartItemType } from "types/CartTypes";
import { EstimatedProductionTimesType } from "types/products/ProductCommandsType";

export type TotalEstimatedProductionTimeType = {
  totalCamTime: number;
  totalPreparationTime: number;
  totalMachiningTime: number;
  totalPostProcessingTime: number;
  totalTime: number;
};

export const CalculateTotalEstimatedProductionTime = (
  cartItems: CartItemType[],
): TotalEstimatedProductionTimeType => {
  let totalCamTime = 0;
  let totalPreparationTime = 0;
  let totalMachiningTime = 0;
  let totalPostProcessingTime = 0;

  cartItems.forEach((item) => {
    if (item.product.estimatedProductionTime === undefined) return;
    const salesProdTime: EstimatedProductionTimesType =
      item.product.estimatedProductionTime;
    totalCamTime += salesProdTime.salesCam || 0;
    totalPreparationTime += salesProdTime.salesPreparation || 0;
    totalMachiningTime += salesProdTime.salesMachining || 0;
    totalPostProcessingTime += salesProdTime.salesPostProcessing || 0;
  });
  const totalTime =
    totalCamTime +
    totalPreparationTime +
    totalMachiningTime +
    totalPostProcessingTime;
  return {
    totalCamTime,
    totalPreparationTime,
    totalMachiningTime,
    totalPostProcessingTime,
    totalTime,
  };
};

const GetTimeString = (totalMinutes: number): string => {
  if (totalMinutes === 0) return "NOT SET";
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  return `${hours}h ${minutes}m`;
};

export const TotalEstimatedProductionTimeTable: FunctionComponent<{
  time: TotalEstimatedProductionTimeType;
  isLoading?: boolean;
}> = ({ time, isLoading }) => (
  <Table size="small" aria-label="a dense table">
    <TableHead>
      <TableRow sx={{ background: "var(--header)" }}>
        <TableCell colSpan={12} sx={{ color: "var(--white)" }}>
          <span>Sales Est. Time</span>
        </TableCell>
      </TableRow>
    </TableHead>
    {!isLoading && (
      <TableBody>
        <TableRow key="camTime">
          <TableCell>CAM Time</TableCell>
          <TableCell align="right">
            {GetTimeString(time.totalCamTime)}
          </TableCell>
        </TableRow>
        <TableRow key="preparationTime">
          <TableCell>Material Time</TableCell>
          <TableCell align="right">
            {GetTimeString(time.totalPreparationTime)}
          </TableCell>
        </TableRow>
        <TableRow key="machiningTime">
          <TableCell>Machining Time</TableCell>
          <TableCell align="right">
            {GetTimeString(time.totalMachiningTime)}
          </TableCell>
        </TableRow>
        <TableRow key="surfaceTreatmentTime">
          <TableCell>QC Time</TableCell>
          <TableCell align="right">
            {GetTimeString(time.totalPostProcessingTime)}
          </TableCell>
        </TableRow>
        <TableRow key="totalTime">
          <TableCell sx={{ fontWeight: "bold" }}>Total Est. Time</TableCell>
          <TableCell align="right" sx={{ fontWeight: "bold" }}>
            {GetTimeString(time.totalTime)}
          </TableCell>
        </TableRow>
      </TableBody>
    )}
  </Table>
);
